import axios from "axios";
import TokenService from "./TokenService";

function getAuthenticatedUser() {
  // If no stored token, no user is authenticated. Return empty object for user
  if (!TokenService.getStoredToken()) {
    return Promise.resolve(null);
  }
  return axios.get(process.env.REACT_APP_API + "/users/current").then((res) => res.data);
}

function createUser() {
  return axios.post(process.env.REACT_APP_API + "/users", {}).then((res) => res.data);
}

function createNonUtahIdUser(user) {
  return axios.post(process.env.REACT_APP_API + "/users/nonUtahId", user).then((res) => res.data);
}

function updateUser(user) {
  return axios.put(process.env.REACT_APP_API + "/users", user).then((res) => res.data);
}

const UserService = {
  getAuthenticatedUser,
  createUser,
  createNonUtahIdUser,
  updateUser,
};

export default UserService;
